/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { DxpServiceId, PERMISSIONS } from '@squiz/dxp-auth';
import { TENANT_SETTINGS_PERMISSION } from '../../../../Services/tenant-settings';
import { hasPermission } from '../../../../Utilities/HasPermission/HasPermission';

/**
 * Check for create permission in at least one service.
 */
export const hasSettingCreatePermission = (): boolean => {
  const createPermissions: Array<string> = [];

  Object.keys(PERMISSIONS).forEach((service) => {
    const servicePermissions = PERMISSIONS[service as DxpServiceId];

    Object.keys(servicePermissions).forEach((permission) => {
      if (permission === TENANT_SETTINGS_PERMISSION.CREATE) {
        createPermissions.push(servicePermissions[permission as keyof typeof servicePermissions]);
      }
    });
  });

  return createPermissions.some((permission) => hasPermission(permission));
};
